import React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { colors } from '../theme/themeConfig';

interface PageSwitcherProps {
  pages: {
    path: string;
    label: string;
  }[];
}

const PageSwitcher: React.FC<PageSwitcherProps> = ({ pages }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const currentPath = location.pathname;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          borderRadius: '0px',
          borderBottomLeftRadius: '12px',
          borderBottomRightRadius: '12px',
          overflow: 'hidden',
          border: `1px solid ${colors.primary.main}`,
          borderTop: 'none',
          backgroundColor: 'rgba(10, 35, 51, 0.8)',
          backdropFilter: 'blur(8px)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        {pages.map((page) => {
          const isActive = currentPath === page.path;
          return (
            <Button
              key={page.path}
              onClick={() => navigate(page.path)}
              sx={{
                py: 0.8,  // Reduced vertical padding
                px: 3,
                borderRadius: 0,
                color: isActive ? '#fff' : theme.palette.text.primary,
                backgroundColor: isActive ? colors.primary.main : 'transparent',
                '&:hover': {
                  backgroundColor: isActive 
                    ? colors.primary.dark 
                    : 'rgba(0, 255, 102, 0.1)',
                },
                fontSize: '14px',  // Slightly smaller font
                fontWeight: 500,
                textTransform: 'none',
                minHeight: '36px',  // Set a specific height
                lineHeight: 1,  // Tighter line height
                flex: 1,  // Make buttons take equal width
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {page.label}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};

export default PageSwitcher;
